import { FileCheck2, LoaderCircle } from "lucide-react";
import { useState } from "react";

export default function PortalTermsAcceptance({ terms, onAccept, state }) {
  const [acknowledged, setAcknowledged] = useState(false);

  const accept = async () => {
    if (!acknowledged) return;
    await onAccept(terms.version);
  };

  return (
    <section className="portal-terms" data-testid="portal-terms-acceptance">
      <FileCheck2 size={32} />
      <span className="eyebrow">Version {terms.version}</span>
      <h2>REVIEW PORTAL TERMS</h2>
      <p>Accept the current terms to access confidential investor materials and renderings.</p>
      <div className="portal-terms-sections" data-testid="portal-terms-sections">
        {terms.sections.map((section) => (
          <article key={section.heading} data-testid={`portal-terms-${section.heading.toLowerCase().replaceAll(" ", "-")}`}>
            <h3>{section.heading}</h3>
            <p>{section.body}</p>
          </article>
        ))}
      </div>
      <label className="check-label portal-terms-check">
        <input
          type="checkbox"
          checked={acknowledged}
          onChange={(event) => setAcknowledged(event.target.checked)}
          data-testid="portal-terms-acknowledgment-checkbox"
        />
        I have reviewed and accept these Investor Portal Terms and Confidentiality Acknowledgment.
      </label>
      {state === "error" && <p className="form-error" data-testid="portal-terms-error">Terms could not be accepted. Please try again.</p>}
      <button
        className="button button--red"
        disabled={!acknowledged || state === "loading"}
        onClick={accept}
        data-testid="portal-terms-accept-button"
      >
        {state === "loading" ? <LoaderCircle className="spin" size={16} /> : <FileCheck2 size={16} />}
        {state === "loading" ? "Accepting…" : "Accept terms to continue"}
      </button>
    </section>
  );
}